<template>
	<vxe-modal v-model="showFlag" title="间隔流量图形" :destroy-on-close="true" :mask="false":lock-view="false" show-zoom resize
					fullscreen remember :esc-closable="true" :before-hide-method="beforeHideMethod">
		<a-layout  style="padding: 0;">
			<a-layout-sider   width="240" theme="light" class="mySider">
				<a-directory-tree multiple  @select="onSelect" :selectedKeys="checkedMonitor"   :defaultSelectedKeys="checkedMonitor">
					<a-tree-node v-for="(item,index) in parentList" :key="item.value" :title="item.name" style="color: white;">
						<a-tree-node  v-for="(subItem,subIndex) in getSubTreeLeafNodeByParent(item.name,item.value)"
														:key="subItem.meterId"  :title="subItem.monitorName" is-leaf />
					</a-tree-node>
				</a-directory-tree>
			</a-layout-sider>
			<a-layout-content style="background-color: white;padding: 0.625rem;">
				<div class="actDiv">
					<label style="font-size: 0.8rem;">给水号：</label>
					<a-input style="width: 10.5rem;" v-model="theApid"  @change="apidChangeHandler"></a-input>
					<label style="font-size: 0.8rem;margin-left: 0.625rem;">时间区间：</label>
					<a-date-picker  v-model="dateStart" style="margin-right: 0.5rem;width: 8rem;"
											:show-time="true" :format="theFormatString" 
											@change="beginDateChangeHandler"/>
					<label >至</label>
					<a-date-picker v-model="dateEnd"  style="margin-left: 0.5rem;width: 8rem;"
									:show-time="true" :format="theFormatString" 
									@change="endDateChangeHandler"/>
					<a-select style="width:5.5rem;  font-size: 0.6875rem;margin-left: 0.625rem;" v-model="theInterval"  allowClear>
						<a-select-option v-for="item in intervalList" :key="item.index" :value="item.index">
							{{item.name}}
						</a-select-option>
					</a-select>
					<a-button size="small"   icon="search" @click="doQuery" style="margin: 0 0.5rem;" :loading="loading">查询</a-button>
					<a-button size="small" style="margin-left: 0.625rem" icon="printer" v-print="printOption"> 打印 </a-button>
					<a-button size="small" style="margin-left: 0.625rem" icon="download" @click="downloadImage()"> 导出图片 </a-button>
				</div>
				<a-tabs type="card">
					<a-tab-pane key="1" tab="抄收报表">
						<a-table  size="small" :columns="columns" :data-source="statisList" bordered :loading="loading"
										rowKey="id" :pagination="false" :scroll="{y:500}" :hideOnSinglePage="false">
						</a-table>
					</a-tab-pane>
					<a-tab-pane key="2" tab="曲线分析图" :forceRender="true">
						<ve-line  id="charts"  :data="statisData"  :settings="chartSettings" :extend="chartExtend" :grid={left:60,right:60}
									  :legend="{ bottom: '0' }" :title="{text:statisTitle,x:'center',y:'top'}" judge-width  height="500px"
									   v-show="statisList.length"/>
					</a-tab-pane>
				</a-tabs>
				
			</a-layout-content>
		</a-layout>
	</vxe-modal>
	
	
</template>

<script>
	const columns = [
		{
			title: '给水号',
			dataIndex: 'apId',
			width:120,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '表地址',
			dataIndex: 'meterAddr',
			width:140,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '监控点名称',
			dataIndex: 'monitorName',
			width:160,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '口径',
			dataIndex: 'caliber',
			width:90,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '表读数',
			dataIndex: 'readData',
			width:110,
			className:'v-cell',
			align:'center',
		},
		{
			title: '间隔流量',
			dataIndex: 'intervalFlow',
			width:100,
			className:'v-cell',
			align:'center',
		},
		{
			title: '上传时间',
			dataIndex: 'readTime',
			width:160,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
	];
	export default {
		data(){
			return {
				theApid:"",
				columns,
				theFormatString:"YYYY-MM-DD HH:mm:ss",
				theInterval:60,
				dataList:[],
				statisList:[],
				loading:false,
				showFlag:false,
				checkedMonitor:[],
				dateStart:null,
				dateEnd:null,
				theDateList:[],
				intervalList:[
					{
						name:"5分钟",
						index:5
					},
					{
						name:"15分钟",
						index:15
					},
					{
						name:"30分钟",
						index:30
					},
					{
						name:"1小时",
						index:60
					},
				],
				statisData:{
					rows:[],
				},
				chartExtend:{
					series:{
						smooth:true,
						type:'line',
					},
					xAxis: {
						axisLabel: {
							interval: 0,
							rotate: 50
						}
					},
				},
				chartSettings:{
					area: false, 
					yAxisName: ['流量'],
					labelMap: {
						intervalFlow: '间隔流量',
					  },
				},
				printOption:{
					id:"charts",
					popTitle:"",
					preview:true,
				},
				parentList:[],
			}
		},
		methods:{
			getSubTreeLeafNodeByParent(parentName,parentKey){
				let temp = [];
				if(parentKey == 0){
					temp = this.Config.deepClone(this.dataList);
				}else{
					let a = parentName.split("(");
					for (var i = 0; i < this.dataList.length; i++) {
						let item =  this.dataList[i];
						if(item.groupName == a[0]){
							temp.push(item);
						}
					}
				}
				return temp;
			},
			createParentList(){
				let titleList = ["监控点"];
				this.dataList.forEach((item)=>{
					if(titleList.indexOf(item.groupName) ==-1){
						titleList.push(item.groupName);
					}
				});
				for (var i = 0; i < titleList.length; i++) {
					let name = titleList[i];
					let array = this.getSubTreeLeafNodeByParent(name,i);
					let title = name+"("+array.length+")";
					let item = {name:title,value:i};
					this.parentList.push(item);
				}
			},
			apidChangeHandler(e){
				let v = e.target.value;
				if(v.length>=10){
					let a= this.getMarkerByApid(v);
					if(a!=null){
						let meterId = a.meterId;
						this.checkedMonitor=[meterId];
					}else{
						this.checkedMonitor=[];
					}
				}else{
					this.checkedMonitor=[];
				}
			},
			getMarkerByApid(apid){
				let result = null;	
				for(var i=0;i<this.dataList.length;i++){
					let item = this.dataList[i];
					if(item.meterApid == apid){
						result = item;
						break;
					}
				}
				return result;
			},
			beginDateChangeHandler(date,dateString){
				this.dateStart = this.$moment(dateString).format(this.theFormatString);
			},
			endDateChangeHandler(date,dateString){
				this.dateEnd = this.$moment(dateString).format(this.theFormatString);
			},
			downloadImage(){
				const charts = document.getElementById("charts").getElementsByTagName('canvas');
				const element = document.createElement("a");
				element.download =this.statisTitle +".png"
				element.href = charts[0].toDataURL("image/png")
				document.body.appendChild(element)
				element.click();
				element.remove();
			},
			beforeHideMethod(){
				this.statisData = {};
				this.statisList = [];
			},
			onChange(date, dateString) {
				this.dateStart=dateString[0];
				this.dateEnd=dateString[1];
			},
			doValid(){
				if(this.dateStart == null || this.dateEnd == null){
					this.$message.error('开始日期和截止日期不能为空');
					return false;
				}
				let a = this.getMarkerByApid(this.theApid);
				if ( a == null) {
					this.$message.error('监控点不存在');
					return false;
				} 
				if(this.checkedMonitor.length == 0){
					this.$message.error('监控点不能为空');
					return false;
				}
				return true;
			},
			doQuery(){
				if(this.doValid()){
					this.loading = true;
					let url = this.Api.getLastUrl(this.Api.METER_MONITOR_INTERVAL_FLOW_STATIS_URL);
					let param = {
						meterId:this.checkedMonitor[0],
						beginTime:this.dateStart,
						endTime:this.dateEnd,
						interval:this.theInterval
					};
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						this.loading = false;
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.statisList = result;
							this.drawEcharts();
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						this.loading = false;
						console.log(error);
					});
				}
			},
			getMeterMonitorList4Map(){
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_MAP_INFO_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
						this.createParentList();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			onSelect(keys, event){
				this.checkedMonitor = keys;
				let item = this.getTheCheckMonitor();
				if(item!=null){
					this.theApid = item.meterApid;
				}
			},
			showView(meterIdList,dStart,dEnd){
				this.showFlag = true;
				this.checkedMonitor = meterIdList;
				if(dStart!=null){
					this.dateStart = dStart;
					this.theDateList[0] = dStart;
				}
				if(dEnd!=null){
					this.dateEnd = dEnd;
					this.theDateList[1] = dEnd;
				}
				if(this.checkedMonitor.length){
					this.doQuery();
				}
			},
			getTheCheckMonitor(){
				var result = null;
				let checkedMeter = this.checkedMonitor[0];
				for(var i=0;i<this.dataList.length;i++){
					let item = this.dataList[i];
					if(checkedMeter == item.meterId){
						result = item;
						break;
					}
				}
				return  result;
			},
			drawEcharts(){
				var rows = [];
				for(var i =0 ;i<this.statisList.length;i++){
					var item = this.statisList[i];
					var obj = {
						"readTime":item.readTime,
						"intervalFlow":item.intervalFlow,
					}
					rows.push(obj);
				}
				var statisData = {
					columns: ['readTime','intervalFlow'],
					rows:rows.reverse(),
				}
				this.statisData = statisData;
			},
		},
		created() {
			this.getMeterMonitorList4Map();
		},
		computed:{
			myTitle:function(){
				let a = this.dataList.length;
				return "监控表("+a+")";
			},
			monitorName:function(){
				let item = this.getTheCheckMonitor();
				if(item == null){
					return "";
				}else{
					return item.monitorName;
				}
			},
			statisTitle:function(){
				return "抄表数据曲线("+this.monitorName+")";
			},
		}
		
	}
</script>

<style>
</style>
